<ng-container *ngIf="block.items.length > 1">
    <ng-container [ngSwitch]="block.bundle">
        <div *ngSwitchCase="'blocco_card_stack'">
            <div class="w-100 container p-0 d-flex flex-wrap justify-content-center align-items-stretch" style="gap: 20px 0;">
                <ng-container *ngFor="let item of block.items; let idx = index;">
                    <div class="{{ classColumn }}" [ngClass]="{'pe-md-3': idx !== block.items.length - 1}">
                        <app-sample-card [block]="item"></app-sample-card>
                    </div>
                </ng-container>
            </div>
        </div>
        <ng-container *ngSwitchCase="'blocco_card'">
            <owl-carousel-o id="blocco_card_carousel" [options]="customOptionsOwl" class="my-2 no-print">
                <ng-container *ngFor="let item of block.items; let idx = index;">
                    <ng-template carouselSlide>
                        <div [style]="{'margin': '0 12px', 'height': '100%'}">
                            <app-sample-card [block]="item"></app-sample-card>
                        </div>
                    </ng-template>
                </ng-container>
            </owl-carousel-o>
            <div class="container-print">
                <ng-container *ngFor="let item of block.items; let idx = index;">
                    <div>
                        <app-sample-card [block]="item"></app-sample-card>
                    </div>
                </ng-container>
            </div>
        </ng-container>
    </ng-container>
</ng-container>